
export const settings = {

    APP_NAME: "Human Resource Development",
    API_SERVER: `https://ihris.moh.gov.et/hrd/api`,
    // API_SERVER: `https://api.hrd.sandboxaddis.com/`,
    // API_SERVER: `http://localhost:5000/`,

    FRONT_URL:'https://hrd.moh.gov.et/',
    // FRONT_URL:'https://dev-hrd.sandboxaddis.com/',
    // FRONT_URL:'http://localhost:8080/',
};
